module.exports = __webpack_public_path__ + "assets/img/specialBg.4a35bf9d.png";